import { render, staticRenderFns } from "./gantt-chart.vue?vue&type=template&id=3ffd9b7e&scoped=true&"
import script from "./gantt-chart.vue?vue&type=script&lang=js&"
export * from "./gantt-chart.vue?vue&type=script&lang=js&"
import style0 from "./gantt-chart.vue?vue&type=style&index=0&id=3ffd9b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffd9b7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VTooltip})
